<template>
  <v-app-bar
    :class="$style['app-header']"
    :height="height"
    color="white"
    elevation="0"
  >
    <v-toolbar-title class="dflex align-center">
      <Logo
        width="195"
        height="60"
        :style="{ display: 'flex', 'align-items': 'center' }"
      />
    </v-toolbar-title>
    <v-toolbar-items>
      <slot name="left" />
    </v-toolbar-items>
    <v-spacer />
    <v-toolbar-items>
      <slot name="right" />
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import Logo from "@/components/logo";
export default {
  components: {
    Logo
  },
  props: {
    height: {
      type: [Number, String],
      default: 50
    }
  }
};
</script>

<style module lang="scss">
.app-header {
  z-index: 3;
  width: 100%;
}
</style>
